module.exports = __webpack_public_path__ + "static/media/face-with-head-bandage-svgrepo-com.dde7f11a.svg";